/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console screen */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import './Button.css';

/**
 * Represents the button component.
 */

export default class Button extends Control {

    /**
     * Properties.
     */

    static propTypes = {
        label:    PropTypes.string.isRequired,
        tooltip:  PropTypes.string,
        onTouch:  PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        mini:     PropTypes.bool,
        width:    PropTypes.number
    }
    
    /**
     * Gets the style of the button.
     * 
     * @return  {Object}    style   style of the button
     */

    getStyle = () => {

        // Preparing

        let style = this._getStyle();
        
        // Adding width attribute
        
        style.width = this.props.width + 'px';

        // Returns the style

        return style;
    }

    /**
     * Events that fires when the user touches the button.
     */

    onTouch = () => {

        // Callbacking the "onTouch" event if the button is enabled

        if (!this.props.disabled) {
            this.props.onTouch(this);
        }
    }

    /**
     * Button renderer.
     */

    render() {
        return (
            <div className={`button ${this.props.mini ? 'buttonmini' : 'buttonnormal'} button${this.props.disabled ? '_disabled' : '_enabled'}`} style={ this.getStyle() } role="button" tabIndex="0" title={this.props.tooltip} onClick={this.onTouch}>
                <div className="button-buttonlabel">{this.props.label}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js